import React from 'react';
import './Header.css';

function Header() {
  return (
    <header className="header">
      <div className="header-inner">
        <div className="logo">
          <div className="logo-icon">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
              <path d="M16 4C10 4 6 8 6 14c0 4 2 7 5 9l1 5h8l1-5c3-2 5-5 5-9 0-6-4-10-10-10z" fill="url(#grad1)" opacity="0.9"/>
              <path d="M12 14c0-2.2 1.8-4 4-4s4 1.8 4 4" stroke="#e879f9" strokeWidth="2" strokeLinecap="round"/>
              <circle cx="16" cy="14" r="2" fill="#e879f9"/>
              <defs>
                <linearGradient id="grad1" x1="6" y1="4" x2="26" y2="32" gradientUnits="userSpaceOnUse">
                  <stop offset="0%" stopColor="#7c3aed"/>
                  <stop offset="100%" stopColor="#a855f7"/>
                </linearGradient>
              </defs>
            </svg>
          </div>
          <div className="logo-text">
            <span className="logo-title">SignSense</span>
            <span className="logo-sub">ASL Recognition</span>
          </div>
        </div>
        <div className="header-badges">
          <span className="badge badge-live">● LIVE</span>
          <span className="badge badge-ai">AI Powered</span>
        </div>
      </div>
    </header>
  );
}

export default Header;
